module.exports = __webpack_public_path__ + "static/media/pathwayCentreLogo.6409215a.png";